export enum JackpotStickyBarTab {
  Gallery = 'Gallery',
  HowItWorks = 'How it Works',
  PrizeDetails = 'Prize Details',
  FAQ = 'FAQ'
}

export enum JackpotPageSection {
  Gallery = 'jackpotGallery',
  HowItWorks = 'jackpotHowWorks',
  PrizeDetails = 'jackpotPrizeDetails',
  FAQ = 'faqSection'
}

export interface CashAlternativeOption {
  value: string;
  title?: string;
  img?: string;
}

export interface JackpotSteps {
  title: string;
  icon: string;
}

export interface JackpotToggleItem {
  expanded: boolean;
  showToggle: boolean;
}
